const levelSelectorStyles = theme => ({ container: { maxWidth: '45%', marginRight: theme.spacing(0) } });

export default levelSelectorStyles;
